import { useEffect, useState } from "react";
import { Button, Card, Grid, Typography, Box } from "@mui/material"
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';

import { iconStyle, cardStyle, butttonWithIcon, secondary_icon } from "../../styles/sharedStyles";
import { CreateFormulation } from "../SubComponents/CreateFormulation";
import { useRef } from "react";


export const ProblemFormulation = () => {

    const pageHeader = {
        fontFamily: "DM Sans, sans-serif",
        fontSize: "24px",
        fontWeight: "bold",
        color: "rgb(27 37 75)",
        display: "flex"
    }

    const buuton1 = {
        // width: "100%",
        marginRight: "8px",
        backgroundColor: "#f6f6ff",
        fontSize: "15px",
        fontWeight: "bold",
        color: "#696cff",
        borderRadius: "10px",
        border: "3px solid #a1a3ff"
    }

    const childRef = useRef();

    const handleClearData = () => {
        console.log("parent component clear data called..........")
        childRef.current.clearData();

    }





    // const [showOrHide, setShowOrHide] = useState(false);

    // const showORhideProblemFormulation = () => {
    //     setShowOrHide(!showOrHide)
    // }

    return (
        <>
            <Grid container spacing={3}>
                <Grid size={10} sx={{
                    padding: "0px 16px", marginTop: "auto",
                    marginBottom: "auto"
                }}>
                    <Typography component="div" sx={pageHeader}><span>Formulate the problem </span>

                        {/* <Box sx={butttonWithIcon} onClick={showORhideProblemFormulation}> {showOrHide ? <DoNotDisturbOnOutlinedIcon sx={secondary_icon} /> : <AddCircleOutlineIcon sx={secondary_icon} />}</Box> */}
                    </Typography>

                </Grid>
                <Grid size={2} sx={{
                    display: "flex",
                    justifyContent: "end",
                }}>
                    <Button variant="contained" sx={buuton1} onClick={handleClearData}><span ><CancelIcon sx={iconStyle} /></span><span>Clear All</span></Button>

                </Grid>

            </Grid>
            {/* {showOrHide ? <CreateFormulation /> : null} */}
            <CreateFormulation ref={childRef} />





        </>
    )
}